/**
 * JamSessionPanelWrapper Component
 * Wrapper for Jam Session panel with transport sync
 */

import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { JamSessionPanel } from '../jam';

export const JamSessionPanelWrapper = ({
  isOpen,
  activeJamSession,
  user,
  setShowJamSessionPanel,
  setActiveJamSession,
  setCurrentTime,
  isPlaying,
  playAll,
  stopAll,
}) => {
  return (
    <AnimatePresence>
      {isOpen && activeJamSession && (
        <div className="fixed top-0 right-0 bottom-0 z-40">
          <JamSessionPanel
            session={activeJamSession}
            userId={user?.id || user?.email}
            userName={user?.name || user?.email?.split('@')[0] || 'Guest User'}
            onClose={() => {
              setShowJamSessionPanel(false);
              setActiveJamSession(null);
            }}
            onTransportSync={(action, position) => {
              if (action === 'play') {
                if (position !== undefined) setCurrentTime(position);
                if (!isPlaying) setTimeout(() => playAll(), 100);
              } else if (action === 'pause' || action === 'stop') {
                stopAll();
              }
            }}
            onTrackUpdate={(data) => {
            }}
          />
        </div>
      )}
    </AnimatePresence>
  );
};

export default JamSessionPanelWrapper;
